import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PersistConfig } from 'redux-persist'
import { storage } from '../core'
import { RecentlyVisitedPage, UtilsState } from './utils.types'

const MAX_RECENTLY_VISITED = 1

const initialState: UtilsState = {
  locale: 'en',
  hotelFilters: undefined,
  recentlyVisitedPages: [],
}

export const UTILS_STATE_NAME = 'utils'

export const utilsSlice = createSlice({
  name: UTILS_STATE_NAME,
  initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<string>) => {
      state.locale = action.payload
    },
    setHotelFilters: (state, action: PayloadAction<UtilsState['hotelFilters']>) => {
      state.hotelFilters = action.payload
    },
    addRecentlyVisitedPage: (state, action: PayloadAction<RecentlyVisitedPage>) => {
      const filtered = state.recentlyVisitedPages.filter(
        (item) => item.href !== action.payload.href,
      )
      state.recentlyVisitedPages = [action.payload, ...filtered].slice(0, MAX_RECENTLY_VISITED)
    },
  },
})

export const utilsSliceConfig: PersistConfig<UtilsState> = {
  storage,
  key: UTILS_STATE_NAME,
  whitelist: ['locale', 'recentlyVisitedPages'],
}
export const { setLocale, setHotelFilters, addRecentlyVisitedPage } = utilsSlice.actions

export default utilsSlice.reducer
